const dispensaryStatesData = {
  data: {
    dispensaryStates: {
      nodes: [
        {
          slug: 'california',
          name: 'California',
          uri: '/dispensary-locations/california/',
          locationsPages: {
            nodes: [
              {
                title: 'Pasadena',
                uri: '/dispensaries/california/pasadena/',
                slug: 'pasadena',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://essencedispensary.com/menus/pasadena-cannabis-menu/',
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/85293178-f621-4816-9845-a88e576a649e/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ca',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'Essence',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'essence-pasadena-dispensary-1-scaled-1',
              sourceUrl:
                'https://cdn.risecannabis.com/wp-content/uploads/2021/11/Essence-Pasadena-Dispensary-1-scaled-1.webp',
              title: 'Essence-Pasadena-Dispensary-1-scaled-1',
              altText: 'Essence-Pasadena-Dispensary',
            },
            stateId: 'CA',
            faqsSubText:
              '<p>Recreational marijuana is now available in California. Visit California dispensary online for all California locations, recreational marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n',
          },
        },
        {
          slug: 'connecticut',
          name: 'Connecticut',
          uri: '/dispensary-locations/connecticut/',
          locationsPages: {
            nodes: [
              {
                title: 'Branford',
                uri: '/dispensaries/connecticut/branford/',
                slug: 'branford',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/connecticut/branford-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/connecticut/branford-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/register/merchant/b6bfdb71-e8e1-4500-9705-7693239402c0/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ct',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Bluepoint Wellness CT)',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-branford',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2023/01/RISE-Branford.webp',
              title: 'RISE-Branford',
              altText: '',
            },
            stateId: 'CT',
            faqsSubText:
              '<p>Recreational and Medical marijuana is now available in Connecticut. Visit our Connecticut <a href="/">cannabis dispensary</a> online for all CT locations, recreational and medical marijuana FAQs, information about how to get a medical card, and how to order online. Find <a href="/dispensaries/">marijuana near me</a>&nbsp;now!</p>\n',
          },
        },
        {
          slug: 'florida',
          name: 'Florida',
          uri: '/dispensary-locations/florida/',
          locationsPages: {
            nodes: [
              {
                title: 'Kendall',
                uri: '/dispensaries/florida/kendall/',
                slug: 'kendall',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/kendall-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/9a38b000-2925-475a-9b84-202133958ae1/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'fl',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'West Palm Beach',
                uri: '/dispensaries/florida/west-palm-beach/',
                slug: 'west-palm-beach',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/west-palm-beach-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/caf95981-89c7-4b1c-9aa0-ec8c2e827ce8/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'fl',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Oviedo',
                uri: '/dispensaries/florida/oviedo/',
                slug: 'oviedo',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/oviedo-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/5f7b2a47-bb23-487a-bdd1-5115f3512766/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'fl',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Bonita Springs',
                uri: '/dispensaries/florida/bonita-springs/',
                slug: 'bonita-springs',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/bonita-springs-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/93e04766-9e7f-494e-8dbb-10a7db23d764/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'fl',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Deerfield Beach',
                uri: '/dispensaries/florida/deerfield/',
                slug: 'deerfield',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/deerfield-beach-medical-pickup-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/deerfield-beach-medical-delivery-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/8350901f-6d1b-485b-90ff-73f839416d9c/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'fl',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Hallandale Beach',
                uri: '/dispensaries/florida/hallandale-beach/',
                slug: 'hallandale-beach',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/hallandale-beach-pickup-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/hallandale-beach-delivery-menu/',
                      },
                      showThisButtonDeliveryPage: true,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/44ede9f8-d3eb-4f3e-8377-aec8ef1a0396/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'fl',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Pinellas Park',
                uri: '/dispensaries/florida/pinellas-park/',
                slug: 'pinellas-park',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/florida/pinellas-park-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/9c44a300-4104-4c8c-86e2-f0e62d5395b4/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'fl',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-florida-dispensaries-2-2',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/RISE-Florida-Dispensaries-2.webp',
              title: 'RISE-Florida-Dispensaries-2',
              altText: 'RISE-Florida-Dispensaries',
            },
            stateId: 'FL',
            faqsSubText:
              '<p>Medical marijuana is now available in Florida. Visit our Florida dispensary online for all Florida locations, medical marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n<p>&nbsp;</p>\n',
          },
        },
        {
          slug: 'illinois',
          name: 'Illinois',
          uri: '/dispensary-locations/illinois/',
          locationsPages: {
            nodes: [
              {
                title: 'Mundelein Lounge',
                uri: '/dispensaries/illinois/mundelein-lounge/',
                slug: 'mundelein-lounge',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/mundelein-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/mundelein-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Make a Reservation',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://foo.com/dispensaries/illinois/mundelein-lounge/?popup=reservation',
                      selectMenuToLinkForProduct: null,
                    },
                    {
                      menuButtonText: 'View Event Calendar',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://foo.com/dispensaries/illinois/mundelein-lounge/?popup=events',
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Charleston',
                uri: '/dispensaries/illinois/charleston/',
                slug: 'charleston',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/charleston-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/7b7f39d3-1d05-4b24-894f-e1b116f0b010/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Lake in the Hills',
                uri: '/dispensaries/illinois/lake-in-the-hills/',
                slug: 'lake-in-the-hills',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/lake-in-the-hills-recreational-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/b44ebfc2-e743-4dc1-b65e-e55603d2f4f9/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Joliet (Rock Creek)',
                uri: '/dispensaries/illinois/joliet-rock-creek/',
                slug: 'joliet-rock-creek',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/joliet-rock-creek-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/joliet-rock-creek-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/f4b75a42-f86c-4276-b553-6a80aa5fe467/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly 3C Compassionate Care Center)',
                    },
                  ],
                },
              },
              {
                title: 'Naperville',
                uri: '/dispensaries/illinois/naperville/',
                slug: 'naperville',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/naperville-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/naperville-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/4552ec17-d64a-4c9d-aa72-9c7fe5d39dbd/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly 3C Compassionate Care Center)',
                    },
                  ],
                },
              },
              {
                title: 'Niles',
                uri: '/dispensaries/illinois/niles/',
                slug: 'niles',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/niles-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/ded72ebe-b760-4303-b436-ed1d73cc9942/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Canton',
                uri: '/dispensaries/illinois/canton/',
                slug: 'canton',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/canton-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/canton-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/dee512fc-6e42-46e8-8f12-5979d737981e/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Joliet (Colorado)',
                uri: '/dispensaries/illinois/joliet-colorado/',
                slug: 'joliet-colorado',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/joliet-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/696da9e7-17fc-4458-b48f-69316b1c0d96/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Mundelein',
                uri: '/dispensaries/illinois/mundelein/',
                slug: 'mundelein',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/mundelein-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/mundelein-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/6e8a6736-0259-4f93-9211-8c40b5f8944b/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Quincy',
                uri: '/dispensaries/illinois/quincy/',
                slug: 'quincy',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/quincy-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/98e03cb6-1df5-49f9-8d8a-65825268de01/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Effingham',
                uri: '/dispensaries/illinois/effingham/',
                slug: 'effingham',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/effingham-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/illinois/effingham-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/8568d625-85dc-4f1f-bb0c-0f8af7959338/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'il',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'mundelein-images-10-31-2',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/Mundelein-Images-10.31-2.webp',
              title: 'Mundelein-Images-10.31-2',
              altText: 'RISE Illinois recreational Dispensaries',
            },
            stateId: 'IL',
            faqsSubText:
              '<p>Recreational and Medical marijuana is now available in Illinois. Visit our Illinois <a href="/">cannabis dispensary</a> online for all Illinois locations, recreational and medical marijuana FAQs, information about how to get a medical card, and how to order online. Find <a href="/dispensaries/">marijuana near me</a> now!</p>\n',
          },
        },
        {
          slug: 'maryland',
          name: 'Maryland',
          uri: '/dispensary-locations/maryland/',
          locationsPages: {
            nodes: [
              {
                title: 'Hagerstown',
                uri: '/dispensaries/maryland/hagerstown/',
                slug: 'hagerstown',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/maryland/hagerstown-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/a7085be7-3827-4fcd-92e8-f54a9b82ad50/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'md',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Maryland Health and Wellness Center Dispensary)',
                    },
                  ],
                },
              },
              {
                title: 'Joppa',
                uri: '/dispensaries/maryland/joppa/',
                slug: 'joppa',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/maryland/joppa-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/7573ca6a-7278-487d-8fa7-05afa76f45de/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'md',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Silver Spring',
                uri: '/dispensaries/maryland/silver-spring/',
                slug: 'silver-spring',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/maryland/silver-spring-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/783656b3-a70c-41b2-b653-a1d9da9eca63/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'md',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Bethesda',
                uri: '/dispensaries/maryland/bethesda/',
                slug: 'bethesda',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/maryland/bethesda-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/maryland/bethesda-delivery-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/65e8e3ec-b7b2-4011-bc56-5fc115ef9b41/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'md',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-maryland-dispensaries',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/RISE-Maryland-Dispensaries.webp',
              title: 'RISE-Maryland-Dispensaries',
              altText: 'RISE Maryland Dispensaries',
            },
            stateId: 'MD',
            faqsSubText:
              '<p>Medical marijuana is now available in Maryland. Visit our Maryland dispensary online for all Maryland locations, medical marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n',
          },
        },
        {
          slug: 'massachusetts',
          name: 'Massachusetts',
          uri: '/dispensary-locations/massachusetts/',
          locationsPages: {
            nodes: [
              {
                title: 'Chelsea',
                uri: '/dispensaries/massachusetts/chelsea/',
                slug: 'chelsea',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/massachusetts/chelsea-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'ma',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Green Star Herbals)',
                    },
                  ],
                },
              },
              {
                title: 'Maynard',
                uri: '/dispensaries/massachusetts/maynard/',
                slug: 'maynard',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/massachusetts/maynard-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'ma',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Green Star Herbals)',
                    },
                  ],
                },
              },
              {
                title: 'West Springfield',
                uri: '/dispensaries/massachusetts/west-springfield/',
                slug: 'west-springfield',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://www.affinityne.com/menu-west-springfield/',
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/1a1ace88-1061-45c0-947c-6d52bbe4420e/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ma',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'Affinity',
                    },
                  ],
                },
              },
              {
                title: 'Boston',
                uri: '/dispensaries/massachusetts/boston/',
                slug: 'boston',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://www.affinityne.com/menu-boston/',
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/14cbbc5a-96d1-4ce9-8ba5-ebcd644d3885/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ma',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'Affinity',
                    },
                  ],
                },
              },
              {
                title: 'Dracut',
                uri: '/dispensaries/massachusetts/dracut/',
                slug: 'dracut',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/massachusetts/dracut-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'ma',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Green Star Herbals)',
                    },
                  ],
                },
              },
              {
                title: 'Amherst',
                uri: '/dispensaries/massachusetts/amherst/',
                slug: 'amherst',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/massachusetts/amherst-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/4029f549-dd67-4152-a215-786b88ea6f11/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ma',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-massachusetts-dispensaries',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/RISE-Massachusetts-Dispensaries.webp',
              title: 'RISE-Massachusetts-Dispensaries',
              altText: 'RISE Massachusetts Dispensaries',
            },
            stateId: 'MA',
            faqsSubText:
              '<p>Recreational and medical marijuana is now available in Massachusetts. Visit our Massachusetts dispensary online for all Massachusetts locations, recreational and medical marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n',
          },
        },
        {
          slug: 'minnesota',
          name: 'Minnesota',
          uri: '/dispensary-locations/minnesota/',
          locationsPages: {
            nodes: [
              {
                title: 'Mankato',
                uri: '/dispensaries/minnesota/mankato/',
                slug: 'mankato',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Dispensary Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/minnesota/mankato-dispensary-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: true,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/378f253e-03bb-4291-b2ea-50be7d128427/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'min',
                  },
                  customCopyRightOnFooter: ['Yes'],
                  customCopyRightText:
                    '<p>Leafline Labs, a <a title="Green Thumb" href="https://www.gtigrows.com/" target="_blank" rel="noopener">GTI Company</a></p>\n',
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'St. Cloud',
                uri: '/dispensaries/minnesota/st-cloud/',
                slug: 'st-cloud',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Dispensary Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/minnesota/st-cloud/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: true,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/4da4fc4b-49f1-44be-a324-abba3616f040/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'min',
                  },
                  customCopyRightOnFooter: ['Yes'],
                  customCopyRightText:
                    '<p>Leafline Labs, a <a title="Green Thumb" href="https://www.gtigrows.com/" target="_blank" rel="noopener">GTI Company</a></p>\n',
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Leafline)',
                    },
                  ],
                },
              },
              {
                title: 'Hibbing',
                uri: '/dispensaries/minnesota/hibbing/',
                slug: 'hibbing',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Dispensary Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/minnesota/hibbing-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: true,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/adbb8de9-a004-48da-b10c-87dd768e9758/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'min',
                  },
                  customCopyRightOnFooter: ['Yes'],
                  customCopyRightText:
                    '<p>Leafline Labs, a <a title="Green Thumb" href="https://www.gtigrows.com/" target="_blank" rel="noopener">GTI Company</a></p>\n',
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Leafline)',
                    },
                  ],
                },
              },
              {
                title: 'Eagan',
                uri: '/dispensaries/minnesota/eagan/',
                slug: 'eagan',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Dispensary Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/minnesota/eagan-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: true,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/cfc85d83-63fb-4d2e-b1f5-a47ae8d0b930/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'min',
                  },
                  customCopyRightOnFooter: ['Yes'],
                  customCopyRightText:
                    '<p>Leafline Labs, a <a title="Green Thumb" href="https://www.gtigrows.com/" target="_blank" rel="noopener">GTI Company</a></p>\n',
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Leafline)',
                    },
                  ],
                },
              },
              {
                title: 'Willmar',
                uri: '/dispensaries/minnesota/willmar/',
                slug: 'willmar',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Dispensary Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/minnesota/willmar-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: true,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/78fad110-18cd-4f16-988c-3852bfc55397/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'min',
                  },
                  customCopyRightOnFooter: ['Yes'],
                  customCopyRightText:
                    '<p>Leafline Labs, a <a title="Green Thumb" href="https://www.gtigrows.com/" target="_blank" rel="noopener">GTI Company</a></p>\n',
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Leafline)',
                    },
                  ],
                },
              },
              {
                title: 'St. Paul',
                uri: '/dispensaries/minnesota/st-paul/',
                slug: 'st-paul',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Dispensary Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/minnesota/st-paul-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: true,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/b381aa32-6247-4720-b9e2-778d43f11547/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'min',
                  },
                  customCopyRightOnFooter: ['Yes'],
                  customCopyRightText:
                    '<p>Leafline Labs, a <a title="Green Thumb" href="https://www.gtigrows.com/" target="_blank" rel="noopener">GTI Company</a></p>\n',
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Leafline)',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-minnesota-dispensary-scaled-2',
              sourceUrl:
                'https://cdn.risecannabis.com/wp-content/uploads/2021/04/Rise-Minnesota-Dispensary-scaled-2.webp',
              title: 'Rise-Minnesota-Dispensary-scaled-2',
              altText: 'Rise-Minnesota-Dispensary',
            },
            stateId: 'MIN',
            faqsSubText:
              '<p>Medical Cannabis is now available in Minnesota. Visit our RISE Minnesota dispensary online for all Minnesota locations, medical cannabis FAQs, information about qualifying conditions, and how to order online.</p>\n',
          },
        },
        {
          slug: 'nevada',
          name: 'Nevada',
          uri: '/dispensary-locations/nevada/',
          locationsPages: {
            nodes: [
              {
                title: 'Reno',
                uri: '/dispensaries/nevada/reno/',
                slug: 'reno',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/reno-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/reno-delivery-menu/',
                      },
                      showThisButtonDeliveryPage: true,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/69d1cf30-af6f-4b1d-ae77-397c6d00e6ce/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Las Vegas',
                uri: '/dispensaries/nevada/cookies-on-the-strip/',
                slug: 'cookies-on-the-strip',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://cookies.co/stores/cookies_las_vegas_strip/legacy-menu',
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://cookies.co/stores/cookies_las_vegas_strip/legacy-menu',
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/12d1fc7c-4ecf-4329-9644-5c42cf7c1a1e/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'Cookies on the Strip',
                    },
                  ],
                },
              },
              {
                title: 'Las Vegas (South Rainbow)',
                uri: '/dispensaries/nevada/south-rainbow/',
                slug: 'south-rainbow',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://essencevegas.com/south-rainbow/',
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink:
                        'https://essencevegas.com/delivery-menu?utm_medium=web&utm_source=nevada-delivery-menu&utm_campaign=south-rainbow',
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/de89b35e-d0bc-4962-a6fc-8a82c904ce89/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'Essence',
                    },
                  ],
                },
              },
              {
                title: 'Henderson',
                uri: '/dispensaries/nevada/henderson/',
                slug: 'henderson',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/henderson/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/henderson-delivery/',
                      },
                      showThisButtonDeliveryPage: true,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/7acaa0b9-488a-4d43-9589-cc6496bf8596/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Essence Dispensaries)',
                    },
                  ],
                },
              },
              {
                title: 'Las Vegas (South Durango)',
                uri: '/dispensaries/nevada/south-durango/',
                slug: 'south-durango',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://essencevegas.com/durango-menu/',
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink:
                        'https://essencevegas.com/delivery-menu?utm_medium=web&utm_source=nevada-delivery-menu&utm_campaign=south-durango',
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/f5ddc22d-a41e-481b-897d-9bea30bfd8e2/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'Essence',
                    },
                  ],
                },
              },
              {
                title: 'Las Vegas (West Tropicana)',
                uri: '/dispensaries/nevada/west-tropicana/',
                slug: 'west-tropicana',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://essencevegas.com/tropicana-west/',
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: true,
                      externalMenuLink:
                        'https://essencevegas.com/delivery-menu?utm_medium=web&utm_source=nevada-delivery-menu&utm_campaign=west-tropicana',
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/496e5182-64d3-4802-a463-ea33dd2442b4/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'Essence',
                    },
                  ],
                },
              },
              {
                title: 'Carson City',
                uri: '/dispensaries/nevada/carson-city/',
                slug: 'carson-city',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/carson-city-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/carson-city-delivery-menu/',
                      },
                      showThisButtonDeliveryPage: true,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/6ec62cf1-f912-4536-9679-958f1b598813/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Spanish Springs',
                uri: '/dispensaries/nevada/spanish-springs/',
                slug: 'spanish-springs',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/spanish-springs-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/nevada/spanish-springs-delivery-menu/',
                      },
                      showThisButtonDeliveryPage: true,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/ab4bef23-acfc-4190-a678-742931cd3b5b/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nv',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-nevada-dispensaries',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/RISE-Nevada-Dispensaries.webp',
              title: 'RISE-Nevada-Dispensaries',
              altText: 'RISE Nevada Dispensaries',
            },
            stateId: 'NV',
            faqsSubText:
              '<p>Recreational and Medical marijuana is now available in Nevada. Visit our Nevada dispensary online for all Nevada locations, recreational and medical marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n<p>&nbsp;</p>\n<p>&nbsp;</p>\n',
          },
        },
        {
          slug: 'new-jersey',
          name: 'New Jersey',
          uri: '/dispensary-locations/new-jersey/',
          locationsPages: {
            nodes: [
              {
                title: 'Bloomfield',
                uri: '/dispensaries/new-jersey/bloomfield/',
                slug: 'bloomfield',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-jersey/bloomfield-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-jersey/bloomfield-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/1454aadb-a6d8-4142-ba2d-fc636126b1f2/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nj',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Paramus',
                uri: '/dispensaries/new-jersey/paramus/',
                slug: 'paramus',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-jersey/paramus-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-jersey/paramus-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/ad410197-9b2c-4fa0-8e04-b0ae8700e3f6/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nj',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Paterson',
                uri: '/dispensaries/new-jersey/paterson/',
                slug: 'paterson',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-jersey/paterson-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-jersey/paterson-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/bf23ab78-48d4-4b6d-925a-a9f315a071df/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'nj',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'new-jersey-adult-use',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/new-jersey-adult-use.webp',
              title: 'new-jersey-adult-use',
              altText: 'new-jersey-adult-use-cannabis-dispensary',
            },
            stateId: 'NJ',
            faqsSubText:
              '<p>Medical &amp; Recreational dispensaries are open now in New Jersey. Visit our New Jersey cannabis dispensary page to find our best dispensaries in NJ, marijuana FAQs, information about how to get a medical card, and how to order NJ marijuana online with the best prices near you.</p>\n',
          },
        },
        {
          slug: 'new-york',
          name: 'New York',
          uri: '/dispensary-locations/new-york/',
          locationsPages: {
            nodes: [
              {
                title: 'Rochester',
                uri: '/dispensaries/new-york/rochester/',
                slug: 'rochester',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-york/rochester-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/4e3d5152-ee96-41f1-a6df-3471a37358d4/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ny',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Fp Wellness)',
                    },
                  ],
                },
              },
              {
                title: 'Halfmoon Clifton Park',
                uri: '/dispensaries/new-york/halfmoon-clifton-park-dispensary/',
                slug: 'halfmoon-clifton-park-dispensary',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-york/halfmoon-clifton-park-dispensary-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-york/halfmoon-clifton-park-delivery-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/525a51d9-f82f-4ee7-b306-3e85c665772f/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ny',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Fp Wellness)',
                    },
                  ],
                },
              },
              {
                title: 'Manhattan NYC',
                uri: '/dispensaries/new-york/manhattan-nyc/',
                slug: 'manhattan-nyc',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/new-york/manhattan-nyc-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/149586d4-daf6-49ff-8b73-6047b1243f42/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'ny',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Fp Wellness)',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'new-york-dispensaries',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/new-york-dispensaries.webp',
              title: 'new-york-dispensaries',
              altText: 'New York Dispensaries',
            },
            stateId: 'NY',
            faqsSubText:
              '<p>Medical marijuana is now available in New York, Visit our New York dispensary online for all New York locations, medical marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n',
          },
        },
        {
          slug: 'ohio',
          name: 'Ohio',
          uri: '/dispensary-locations/ohio/',
          locationsPages: {
            nodes: [
              {
                title: 'Lakewood (Madison)',
                uri: '/dispensaries/ohio/lakewood-madison/',
                slug: 'lakewood-madison',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/ohio/lakewood-madison-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'oh',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Lakewood (Detroit)',
                uri: '/dispensaries/ohio/lakewood-detroit/',
                slug: 'lakewood-detroit',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/ohio/lakewood-detroit-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'oh',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Cleveland',
                uri: '/dispensaries/ohio/cleveland/',
                slug: 'cleveland',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/ohio/cleveland-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'oh',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Lorain',
                uri: '/dispensaries/ohio/lorain/',
                slug: 'lorain',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/ohio/lorain-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'oh',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Toledo',
                uri: '/dispensaries/ohio/toledo/',
                slug: 'toledo',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/ohio/toledo-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl: null,
                  overview: {
                    stateId: 'oh',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-ohio-dispensaries',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/RISE-Ohio-Dispensaries.webp',
              title: 'RISE-Ohio-Dispensaries',
              altText: 'RISE Ohio Dispensaries',
            },
            stateId: 'OH',
            faqsSubText:
              '<p>Medical marijuana is now available in Ohio. Visit our Ohio dispensary online for all Ohio locations, medical marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n',
          },
        },
        {
          slug: 'pennsylvania',
          name: 'Pennsylvania',
          uri: '/dispensary-locations/pennsylvania/',
          locationsPages: {
            nodes: [
              {
                title: 'Warminster',
                uri: '/dispensaries/pennsylvania/warminster/',
                slug: 'warminster',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/warminster-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/24b77f9b-09f1-4198-928d-440820e7796d/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Meadville',
                uri: '/dispensaries/pennsylvania/meadville/',
                slug: 'meadville',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/meadville-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/4d225615-f0a4-4034-9012-b86f8e99e5c8/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Erie (Peach)',
                uri: '/dispensaries/pennsylvania/erie-peach/',
                slug: 'erie-peach',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/erie-peach-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/6ca936ea-609c-4a50-8e62-106e939bb79f/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Monroeville',
                uri: '/dispensaries/pennsylvania/monroeville/',
                slug: 'monroeville',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/monroeville-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/352de9be-9b47-459d-ac5f-3d7dafe5f935/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Duncansville',
                uri: '/dispensaries/pennsylvania/duncansville/',
                slug: 'duncansville',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/duncansville-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/54b30a3f-b619-4b3d-ad47-5cd47caeb07e/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Chambersburg',
                uri: '/dispensaries/pennsylvania/chambersburg/',
                slug: 'chambersburg',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/chambersburg-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/3e0d194a-4071-40f1-a455-e1251bb1c4ee/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Cranberry',
                uri: '/dispensaries/pennsylvania/cranberry/',
                slug: 'cranberry',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/cranberry-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/4aed22ea-69c8-463e-9c13-13759ab54f14/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'New Castle',
                uri: '/dispensaries/pennsylvania/new-castle/',
                slug: 'new-castle',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/new-castle-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/9d4f8f4d-4214-4e16-904a-3b91e98628b8/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'King of Prussia',
                uri: '/dispensaries/pennsylvania/king-of-prussia/',
                slug: 'king-of-prussia',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/king-of-prussia-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/0883c16e-6006-4077-848f-ec57150f5a6b/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Hermitage',
                uri: '/dispensaries/pennsylvania/hermitage/',
                slug: 'hermitage',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/hermitage-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/32fb8fc9-9e48-4d81-a1bf-c5ca2f07ff4e/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Mechanicsburg',
                uri: '/dispensaries/pennsylvania/mechanicsburg/',
                slug: 'mechanicsburg',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/mechanicsburg-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/3cf8f6de-31dc-4306-8b83-861e4b734cc8/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Latrobe',
                uri: '/dispensaries/pennsylvania/latrobe/',
                slug: 'latrobe',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/latrobe-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/c500f238-8c76-49eb-a503-ea268438552c/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'York',
                uri: '/dispensaries/pennsylvania/york/',
                slug: 'york',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/york-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/ea0537b7-14e6-40aa-a63b-844fd151bfa5/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Erie (Lake)',
                uri: '/dispensaries/pennsylvania/erie-lake/',
                slug: 'erie-lake',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/erie-lake-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/6ca936ea-609c-4a50-8e62-106e939bb79f/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Carlisle',
                uri: '/dispensaries/pennsylvania/carlisle/',
                slug: 'carlisle',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/carlisle-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/d20d8829-dc21-4956-a61b-fa801d667662/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Steelton',
                uri: '/dispensaries/pennsylvania/steelton/',
                slug: 'steelton',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/pennsylvania/steelton-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/76f0e31c-8eef-4fce-8ae0-16f2877d7d18/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'pa',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-pennsylvania-dispensaries',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/RISE-Pennsylvania-Dispensaries.webp',
              title: 'RISE-Pennsylvania-Dispensaries',
              altText: 'RISE Pennsylvania Dispensaries',
            },
            stateId: 'PA',
            faqsSubText:
              '<p>Medical marijuana is now available in Pennsylvania. Visit our Pennsylvania dispensary online for all Pennsylvania locations, medical marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n',
          },
        },
        {
          slug: 'rhode-island',
          name: 'Rhode Island',
          uri: '/dispensary-locations/rhode-island/',
          locationsPages: {
            nodes: [
              {
                title: 'Warwick',
                uri: '/dispensaries/rhode-island/warwick/',
                slug: 'warwick',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Recreational Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/rhode-island/warwick-adult-use-rec-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/rhode-island/warwick-dispensary-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: true,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/ed4d5413-bf30-49ff-bcaa-e8eb6e11ea89?/loc_v_name=gti_website',
                  overview: {
                    stateId: 'ri',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE (formerly Summit Medical Compassion Center)',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-dispensaries-warwick',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/11/RISE-Dispensaries-Warwick.webp',
              title: 'RISE-Dispensaries-Warwick',
              altText: 'RISE-Dispensaries-Warwick',
            },
            stateId: 'RI',
            faqsSubText:
              '<p>Medical and Recreational marijuana is now available in Rhode Island. Visit Rhode Island dispensary online for all Rhode Island locations, medical and recreational marijuana FAQs, information about how to get a medical card, and how to order online.</p>\n',
          },
        },
        {
          slug: 'virginia',
          name: 'Virginia',
          uri: '/dispensary-locations/virginia/',
          locationsPages: {
            nodes: [
              {
                title: 'Bristol',
                uri: '/dispensaries/virginia/bristol/',
                slug: 'bristol',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Shop Abingdon Dispensary',
                      menuLinksTo: {
                        uri: '/dispensary-menu/virginia/abingdon-pickup-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: null,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/6da76b25-d64c-4b4a-906c-36de34608392/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'va',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Christiansburg',
                uri: '/dispensaries/virginia/christiansburg/',
                slug: 'christiansburg',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'medical menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/virginia/christiansburg-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: true,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/bfaad92d-e0f9-46e2-9a6f-c1cb1331f5b9/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'va',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Lynchburg',
                uri: '/dispensaries/virginia/lynchburg/',
                slug: 'lynchburg',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/virginia/lynchburg-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: true,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/e46301b3-6c51-4777-aeaa-3f89b63960bc/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'va',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Abingdon',
                uri: '/dispensaries/virginia/abingdon/',
                slug: 'abingdon',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Pickup Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/virginia/abingdon-pickup-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                    {
                      menuButtonText: 'Delivery Menu',
                      menuLinksTo: null,
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: 'https://www.highroaddelivery.com/vendors/riseabingdon',
                      selectMenuToLinkForProduct: null,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: true,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/6da76b25-d64c-4b4a-906c-36de34608392/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'va',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
              {
                title: 'Salem',
                uri: '/dispensaries/virginia/salem/',
                slug: 'salem',
                locationMeta: {
                  menuButtons: [
                    {
                      menuButtonText: 'Medical Menu',
                      menuLinksTo: {
                        uri: '/dispensary-menu/virginia/salem-medical-menu/',
                      },
                      showThisButtonDeliveryPage: null,
                      externalMenuLink: null,
                      selectMenuToLinkForProduct: true,
                    },
                  ],
                  hasActiveHighRisersProgram: null,
                  hasActiveRisersProgram: true,
                  hasActiveRisersProgramMn: null,
                  hasActiveRisersProgramPa: null,
                  hasActiveRisersProgramRi: null,
                  loyaltyFormUrl:
                    'https://loyalty.riseq.com/join/merchant/ce205397-82b5-49c7-8644-4ca480214fd4/web/?loc_v_name=gti_website',
                  overview: {
                    stateId: 'va',
                  },
                  customCopyRightOnFooter: null,
                  customCopyRightText: null,
                },
                brandsTaxonomy: {
                  nodes: [
                    {
                      name: 'RISE',
                    },
                  ],
                },
              },
            ],
          },
          state: {
            heroImage: {
              mediaType: 'image',
              slug: 'rise-virginia-dispensaries',
              sourceUrl: 'https://cdn.risecannabis.com/wp-content/uploads/2021/04/RISE-Virginia-Dispensaries.webp',
              title: 'RISE-Virginia-Dispensaries',
              altText: 'RISE Virginia Dispensaries',
            },
            stateId: 'VA',
            faqsSubText:
              '<p>Medical marijuana is now available in Virginia. Visit our Virginia dispensary online to see Virginia dispensary locations, VA medical marijuana FAQs, information about how to get a medical card in Virginia, and how to order online.</p>\n',
          },
        },
      ],
    },
  },
};

export default dispensaryStatesData;
/***
 Query Last update: 03/01/2023 ~ jerry.l
 Note: This was copy from CoFe repo.
 ***/

/*
NOTE: query to generate dummy json. Need to convert json to JS object. faqsSubText will lose its end quote after converting, need to add it back
query {
  dispensaryStates(first: 25, where: {parent: 0}) {
    nodes {
      slug
      name
      uri
      locationsPages(first: 25) {
        nodes {
          title
          uri
          slug
          locationMeta {
            menuButtons {
              menuButtonText
              menuLinksTo {
                ... on MenuPage {
                  uri
                }
              }
              showThisButtonDeliveryPage
              externalMenuLink
              selectMenuToLinkForProduct
            }
            hasActiveHighRisersProgram
            hasActiveRisersProgram
            hasActiveRisersProgramMn
            hasActiveRisersProgramPa
            hasActiveRisersProgramRi
            loyaltyFormUrl
            overview {
              stateId
            }
            customCopyRightOnFooter
            customCopyRightText
          }
          brandsTaxonomy {
            nodes {
              name
            }
          }
        }
      }
      state {
        heroImage {
          mediaType
          slug
          sourceUrl
          title
          altText
        }
        stateId
        faqsSubText
      }
    }
  }
}
*/
